import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Button, Checkbox, message, Alert } from 'antd';
import { getKvkkPending, acceptKvkk, decideStudentKvkkConsent } from '../../api/kvkk';
import { logout as logoutApi } from '../../api/auth';
import useAuthStore from '../../store/authStore';
import { sanitizeHtml } from '../../utils/sanitizeHtml';

const KvkkConsentModal = () => {
  const [queue, setQueue] = useState([]);
  const [index, setIndex] = useState(0);
  const [checked, setChecked] = useState(false);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();
  const storeLogout = useAuthStore(s => s.logout);
  const isImpersonating = useAuthStore(s => s.isImpersonating);
  const [bilgiKapatildi, setBilgiKapatildi] = useState(false);

  const handleLogout = async () => {
    try { await logoutApi(); } catch { /* token süresi dolmuş olabilir */ }
    storeLogout();
    navigate('/login');
  };

  useEffect(() => {
    const check = async () => {
      try {
        const res = await getKvkkPending();
        if (res.data.data?.length) {
          setQueue(res.data.data);
        }
      } catch {
        // sessiz geç
      }
    };
    check();
  }, []);

  const current = queue[index];

  const handleAccept = async () => {
    if (!checked || !current) {
      message.warning('Devam etmek için metni onaylamanız gerekiyor.');
      return;
    }
    setSaving(true);
    try {
      if (current.scope === 'student') {
        await decideStudentKvkkConsent(current.student_id, current.type, 'accept');
      } else {
        await acceptKvkk(current.type);
      }
      setChecked(false);
      setIndex(i => i + 1);
    } catch {
      message.error('Onay kaydedilemedi, lütfen tekrar deneyin.');
    } finally {
      setSaving(false);
    }
  };

  if (!current) return null;

  // TAKLİT OTURUMUNDA KAPANABİLİR BİLGİ PENCERESİ.
  //
  // Onay, kişinin kendi beyanı olduğu için taklitte VERİLEMİYOR
  // (KvkkController::taklitteRizaVerilemez, 403) — bu kasıtlı ve doğru.
  // Ama bu pencere `closable={false}` olduğu için yönetici kapana
  // kısılıyordu: "Onaylıyorum" 403 dönüyor, kapatma yok, tek çıkış
  // "çıkış yap" — o da yöneticinin KENDİ oturumunu kapatıyor.
  //
  // Sunucu tarafında taklit zaten onay kapısından muaf
  // (RequireKvkkConsent), yani pencerenin engelleyici olması için bir
  // sebep yok. Bekleyen onaylar bilgi olarak gösteriliyor: yönetici
  // veliyi neden eksik gördüğünü anlıyor ve arayabiliyor.
  if (isImpersonating) {
    if (bilgiKapatildi) return null;

    return (
      <Modal
        open
        title="Bekleyen onay metinleri"
        onCancel={() => setBilgiKapatildi(true)}
        footer={<Button onClick={() => setBilgiKapatildi(true)}>Kapat</Button>}
        width={560}
      >
        <Alert
          type="info"
          showIcon
          message="Bu kullanıcı adına onay veremezsiniz"
          description="Onay kişinin kendi beyanıdır ve kanıt olarak IP ile cihaz bilgisi saklanır. Taklit oturumunda verilen bir onay, kullanıcının hiç görmediği bir beyan kaydı oluştururdu. Onayı kullanıcının kendisinin vermesi gerekiyor."
        />
        <ul className="mt-3 pl-5 list-disc text-sm text-gray-700">
          {queue.map((k, i) => (
            <li key={i}>
              {k.label}
              {k.scope === 'student' && k.student_name ? ` — ${k.student_name}` : ''}
            </li>
          ))}
        </ul>
      </Modal>
    );
  }

  const title = current.scope === 'student'
    ? `${current.label} — ${current.student_name}`
    : current.label;

  return (
    <Modal
      open
      title={`${title} (Versiyon ${current.text.version})`}
      closable={false}
      maskClosable={false}
      footer={null}
      width={700}
    >
      <div
        className="max-h-96 overflow-y-auto p-4 border border-gray-200 rounded bg-gray-50 kvkk-content"
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(current.text.content) }}
      />
      <style>{`
        .kvkk-content h2 { font-size: 1.1rem; font-weight: 700; margin: 12px 0 6px; }
        .kvkk-content h3 { font-size: 0.95rem; font-weight: 600; margin: 10px 0 4px; }
        .kvkk-content p  { margin: 0 0 8px; line-height: 1.7; }
      `}</style>
      <div className="mt-4 flex flex-col gap-3">
        <Checkbox checked={checked} onChange={e => setChecked(e.target.checked)}>
          Bu metni okudum ve anladım.
        </Checkbox>
        <Button type="primary" onClick={handleAccept} loading={saving} disabled={!checked} style={{ width: '100%' }}>
          Onaylıyorum
        </Button>
        <Button type="link" onClick={handleLogout} style={{ padding: 0, alignSelf: 'center' }}>
          Onaylamak istemiyorum, çıkış yap
        </Button>
      </div>
    </Modal>
  );
};

export default KvkkConsentModal;
